import { render } from "./DiscountTransactionsSection.vue?vue&type=template&id=19f98eac&scoped=true"
import script from "./DiscountTransactionsSection.vue?vue&type=script&lang=js"
export * from "./DiscountTransactionsSection.vue?vue&type=script&lang=js"

import "./DiscountTransactionsSection.vue?vue&type=style&index=0&id=19f98eac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f98eac"]])

export default __exports__